import {pack} from './pack'
import {unpack} from './unpack'
import type {CorePlugin, SingleComponentPlugin} from '../../types'
import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'

/**
 * For every property whose value is an object containing an innerElements object (the map),
 * replace that value with its innerElements and drop the wrapper (including its type)
 */
export const innerElementsMapSingleComponentPlugin = {
    name: 'InnerElementsMapPlugin',
    pack,
    unpack
} satisfies SingleComponentPlugin

export const innerElementsMapPlugin: CorePlugin = createPluginFromSingleComponentPlugin(
    innerElementsMapSingleComponentPlugin
)
